import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {boolean} */
const initialState = false;

const isLoading = () => true;

const isEnding = () => false;

export default createReducer(initialState, {
  [types.STATISTICS_DEALER_EXPORT]: isLoading,
  [types.STATISTICS_DEALER_EXPORT_FAILURE]: isEnding,
  [types.STATISTICS_DEALER_EXPORT_SUCCESS]: isEnding,
});
